import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DatabaseTableTypeSelectField } from '../components/Table/fields/DatabaseTableTypeSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { Custom } from '../types/entities/Custom';
import { SPSelectField } from '../components/Table/fields/SPSelectField';

export const custom: SchemaWithClient<Custom> = {
  name: 'Custom Field',
  pluralName: 'Custom Field',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    type: {
      name: 'Column Type',
      fieldRenderer: DatabaseTableTypeSelectField,
      slidePaneFieldRenderer: DatabaseTableTypeSelectField,
      switchboard: true,
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      switchboard: true,
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      readOnly: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/custom-fields'),
};
